







































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineLabReport1V2DataAnalysis',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        dataAnalysisAnswer: null,
      },
      attachments: [] as File[],
      questions: [
        {
          text: 'In the space below, please write your data analysis.',
          inputName: 'dataAnalysisAnswer',
          maxInputLength: 2000,
        },
      ],
    };
  },
});
